/**
 * safeStorage — the house wrappers around `localStorage`.
 *
 * Every read/write is in a try/catch so Safari private mode, a disabled-storage policy or a
 * quota error can never crash the app: a failed read looks like "nothing stored", a failed
 * write is simply not persisted, and the caller's in-memory state stays correct.
 *
 * Extracted from `authStore.js` (which still owns the auth keys) so other module stores —
 * `sidebarPref.js` today — share exactly the same semantics instead of re-rolling them.
 */

/** @param {string} key @returns {string | null} */
export function safeGet(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

/** @param {string} key @param {string} val */
export function safeSet(key, val) {
  try {
    localStorage.setItem(key, val);
  } catch {
    // best-effort persistence — in-memory state is still correct
  }
}

/** @param {string} key */
export function safeRemove(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // swallow
  }
}
